import { LIBRARY } from '../../const';

//----------------------------------------------------------------------------------------------------------------------
export let calculateTagsNumber = (tagsWidths, containerWidth) => {
  const maxWidth = containerWidth - 70;
  let number = 0;
  let sumTagsWidth = 0;
  for (let i = 0; i < tagsWidths.length; i++) {
    sumTagsWidth += tagsWidths[i];

    if (sumTagsWidth < maxWidth) number++;
  }

  return number;
};

//----------------------------------------------------------------------------------------------------------------------
export let getTagsAndMetadataList = (tags, metadata) => {
  let metadataList = [];
  if (metadata && metadata.length) {
    metadataList.push.apply(metadataList, getMetadataByFilterType(metadata, LIBRARY.FILTER_TYPE.PRIMARY_FILTER));
    metadataList.push.apply(metadataList, getMetadataByFilterType(metadata, LIBRARY.FILTER_TYPE.SECONDARY_FILTER));
    metadataList.push.apply(metadataList, getMetadataByFilterType(metadata, LIBRARY.FILTER_TYPE.TERTIARY_FILTER));
  }

  if (tags && tags.length) {
    metadataList.push.apply(metadataList, tags);
  }

  return metadataList;
};

//----------------------------------------------------------------------------------------------------------------------
let getMetadataByFilterType = (metadatas, metadataFilterType) => {
  let metaDataValuesList = [];

  for (let i = 0; i < metadatas.length; i++) {
    let metadata = metadatas[i];

    if (metadata && metadata.metadataFilterType === metadataFilterType) {
      metaDataValuesList.push(metadata.metadataValue);
    }
  }

  return metaDataValuesList;
};
